import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import EnterpriseService from "../../services/EnterpriseService";
import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  enterpriseDetailsSuccess,
  enterpriseDetailsFail,
} from "../slices/enterpriseSlice";
import {
  setEnterpriseSuccess,
  setEnterpriseFail,
  updateSelfEnterpriseSuccess,
  updateSelfEnterpriseFail,
  enterpriseSMTPDetailsSuccess,
  enterpriseSMTPDetailsFail,
  updateEnterpriseSMTPSuccess,
  updateEnterpriseSMTPFail,
  emailBannerDetailsSuccess,
  emailBannerDetailsFail,
  updateEmailBannerSuccess,
  updateEmailBannerFail,
  learnerConfigurationSuccess,
  learnerConfigurationFail,
  updateLearnerConfigurationSuccess,
  updateLearnerConfigurationFail,
  updateLanguageConfigurationSuccess,
  updateLanguageConfigurationFail,
  languageConfigurationSuccess,
  languageConfigurationFail,
} from "../slices/globalSlice";

function* list(data) {
  try {
    const ajax = yield call(EnterpriseService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(EnterpriseService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(EnterpriseService.details, data.payload);
    if (ajax.status === 200) {
      yield put(enterpriseDetailsSuccess(ajax.data));
    } else {
      yield put(
        enterpriseDetailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      enterpriseDetailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* getDomainDetails({ payload }) {
  try {
    const ajax = yield call(EnterpriseService.getDomainDetails, payload.domain);
    if (ajax.status === 200) {
      yield put(setEnterpriseSuccess(ajax.data));
    } else {
      yield put(
        setEnterpriseFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      setEnterpriseFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateSelfEnterprise(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfEnterpriseUpdate,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateSelfEnterpriseSuccess(ajax.data));
    } else {
      yield put(
        updateSelfEnterpriseFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateSelfEnterpriseFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* emailBannerDetails(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfEmailBannerDetails,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(emailBannerDetailsSuccess(ajax.data));
    } else {
      yield put(
        emailBannerDetailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      emailBannerDetailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateEmailBanner(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfEmailBannerUpdateDetails,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateEmailBannerSuccess(ajax.data));
    } else {
      yield put(
        updateEmailBannerFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateEmailBannerFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* smtpDetails(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfEnterpriseSMTPDetails,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(enterpriseSMTPDetailsSuccess(ajax.data));
    } else {
      yield put(
        enterpriseSMTPDetailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      enterpriseSMTPDetailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateSmtpDetails(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfEnterpriseSMTPUpdate,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateEnterpriseSMTPSuccess(ajax.data));
    } else {
      yield put(
        updateEnterpriseSMTPFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateEnterpriseSMTPFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learnerConfiguration(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfLearnerConfiguration,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learnerConfigurationSuccess(ajax.data));
    } else {
      yield put(
        learnerConfigurationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learnerConfigurationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateLearnerConfiguration(data) {
  try {
    const ajax = yield call(
      EnterpriseService.updateSelfLearnerConfiguration,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateLearnerConfigurationSuccess(ajax.data));
    } else {
      yield put(
        updateLearnerConfigurationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateLearnerConfigurationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* languageConfiguration(data) {
  try {
    const ajax = yield call(
      EnterpriseService.selfLanguageConfiguration,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(languageConfigurationSuccess(ajax.data));
    } else {
      yield put(
        languageConfigurationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      languageConfigurationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateLanguageConfiguration(data) {
  try {
    const ajax = yield call(
      EnterpriseService.updateSelfLanguageConfiguration,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateLanguageConfigurationSuccess(ajax.data));
    } else {
      yield put(
        updateLanguageConfigurationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateLanguageConfigurationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* enterpriseSaga() {
  yield all([
    takeLatest("enterprises/listRequest", list),
    takeLatest("enterprises/createRequest", create),
    takeLatest("enterprises/enterpriseDetailsRequest", details),
    takeLatest("global/requestEnterprise", getDomainDetails),
    takeLatest("global/updateSelfEnterpriseRequest", updateSelfEnterprise),
    takeLatest("global/enterpriseSMTPDetailsRequest", smtpDetails),
    takeLatest("global/updateEnterpriseSMTPRequest", updateSmtpDetails),
    takeLatest("global/emailBannerDetailsRequest", emailBannerDetails),
    takeLatest("global/updateEmailBannerRequest", updateEmailBanner),
    takeLatest("global/learnerConfigurationRequest", learnerConfiguration),
    takeLatest(
      "global/updateLearnerConfigurationRequest",
      updateLearnerConfiguration
    ),
    takeLatest("global/languageConfigurationRequest", languageConfiguration),
    takeLatest(
      "global/updateLanguageConfigurationRequest",
      updateLanguageConfiguration
    ),
  ]);
}
